// ScreenSettingsStore.js

import { writable, get } from 'svelte/store';        // this now has set() update() and subscribe() methods

// these are needed to retain settings when returning to the SearchPage

export const isShowingZipError = writable(false);

export const isShowingSearchOptions = writable(false);
export const isShowingSearchResults = writable(false);
export const isShowingUserProfile = writable(false);

// 06/07 - support for public TaxonomyMenu system
export const isShowingTaxonomySubmenu = writable(false);
export const isShowingSearchFilters = writable(false);
export const isRunningSearch = writable(false);
export const isShowingPublicFilterResults = writable(false);
export const isShowingResourceList = writable(false);                       // new 11/16

// export const isShowingPublicResultsCount = writable(false);
export const isShowingUserTips = writable(false);
export const resourcesPageVisitCount = writable(0);

// 06/24 - support for resize events
export const isWindowNarrowView = writable(false);
export const isWindowMediumView = writable(false);
export const isWindowWideView = writable(false);



// 06/30 - breadcrumb is a snapshot array of the five menu node labels (not nodes)
export const taxonomyMenuBreadcrumb = writable(['', '', '', '', '']);

export const setTaxonomyMenuBreadcrumb = (taxonomy) => {
    let crumbs = get(taxonomyMenuBreadcrumb);
    taxonomy.currentNode0 ? crumbs[0] = taxonomy.currentNode0.label : crumbs[0] = '';
    taxonomy.currentNode1 ? crumbs[1] = taxonomy.currentNode1.label : crumbs[1] = '';
    taxonomy.currentNode2 ? crumbs[2] = taxonomy.currentNode2.label : crumbs[2] = '';
    taxonomy.currentNode3 ? crumbs[3] = taxonomy.currentNode3.label : crumbs[3] = '';
    taxonomy.currentNode4 ? crumbs[4] = taxonomy.currentNode4.label : crumbs[4] = '';
}

export const clearTaxonomyMenuBreadcrumb = () => {
    let crumbs = get(taxonomyMenuBreadcrumb);
    crumbs[0] = '';
    crumbs[1] = '';
    crumbs[2] = '';
    crumbs[3] = '';
    crumbs[4] = '';
    taxonomyMenuBreadcrumb.set(crumbs);
}

// yes I know there is a better way to do this!
export const getBreadcrumbLength = (breadcrumb) => {
    let length = 0;
    if (breadcrumb[0] !== '') length++;
    if (breadcrumb[1] !== '') length++;
    if (breadcrumb[2] !== '') length++;
    if (breadcrumb[3] !== '') length++;
    if (breadcrumb[4] !== '') length++;
    return length;    
}

// 09/14 - support for scrolling to last opened List item
export const currentListItemId = writable('');
